export default "__VITE_ASSET__CYmnsxRK__"